var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRing20(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 4731"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 74 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99986 12.3518C13.2319 12.3518 14.646 10.2341 14.646 9.00006C14.646 7.76605 13.2319 5.64833 9.99986 5.64833C6.76778 5.64833 5.35377 7.76605 5.35377 9.00006C5.35377 10.2341 6.76778 12.3518 9.99986 12.3518ZM9.99986 16.8126C15.0295 16.8126 19.1068 13.3148 19.1068 9.00006C19.1068 4.6853 15.0295 1.1875 9.99986 1.1875C4.97025 1.1875 0.892944 4.6853 0.892944 9.00006C0.892944 13.3148 4.97025 16.8126 9.99986 16.8126Z",
    fill: "#95E3FB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0089 14.9678C14.8464 14.9678 18.7679 11.5438 18.7679 7.32012C18.7679 6.87011 18.7234 6.42917 18.638 6.00049C19.1125 6.94406 19.3749 7.98153 19.3749 9.07059C19.3749 13.4243 15.1816 16.9537 10.0089 16.9537C4.83623 16.9537 0.642944 13.4243 0.642944 9.07059C0.642944 7.98153 0.905329 6.94405 1.37979 6.00049C1.29439 6.42917 1.24988 6.8701 1.24988 7.32012C1.24988 11.5438 5.17143 14.9678 10.0089 14.9678Z",
    fill: "#00C2FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0053 9.02313C15.1038 8.70286 15.1561 8.36791 15.1561 8.02313C15.1561 5.73218 12.8476 3.875 9.99988 3.875C7.15216 3.875 4.84363 5.73218 4.84363 8.02313C4.84363 8.36791 4.89591 8.70286 4.99445 9.02313C5.55068 7.21525 7.58072 5.875 9.99988 5.875C12.419 5.875 14.4491 7.21526 15.0053 9.02313Z",
    fill: "#00C2FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 74 (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99986 12.3518C13.2319 12.3518 14.646 10.2341 14.646 9.00006C14.646 7.76605 13.2319 5.64833 9.99986 5.64833C6.76778 5.64833 5.35377 7.76605 5.35377 9.00006C5.35377 10.2341 6.76778 12.3518 9.99986 12.3518ZM9.99986 16.8126C15.0295 16.8126 19.1068 13.3148 19.1068 9.00006C19.1068 4.6853 15.0295 1.1875 9.99986 1.1875C4.97025 1.1875 0.892944 4.6853 0.892944 9.00006C0.892944 13.3148 4.97025 16.8126 9.99986 16.8126Z",
    stroke: "#222627",
    strokeWidth: 1.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRing20);
export default __webpack_public_path__ + "static/media/ring_20.f9f28d5e02af9b2ee73deca842c478b5.svg";
export { ForwardRef as ReactComponent };